let Event  = {
  EMAIL_COLLECTION_FORM_VIEW: 'Email Collection Form View',
  EMAIL_COLLECTION_SUBMISSION: 'Email Collection Submission',
  LOGIN_FORM_VIEW: 'Login Form View',
  PASSWORD_RECOVERY_SUBMISSION: 'Password Recovery Submission',
  LOGIN: 'Login',
  ACCOUNT_CREATION: 'Account Creation',
  FINAL_STEP_COMPLETED: 'Final Step Completed'
};

export default Event;



// WEBPACK FOOTER //
// ./src/library/domain/Event.js